// Insight widgets (stat cards / charts) exist for the 8 standard report tabs — not for the CDM
// finder/recall/register (their own criteria-driven UI, no meaningful "totals" to summarise), the
// medico-legal report (no dedicated tab/filters wired up yet), or patient merges (no backend
// /summary endpoint — a merge-history report has no "totals" dashboard worth building yet).
const UNSUPPORTED_REPORT_TYPES = new Set([
  "cdm-finder",
  "cdm-recall",
  "cdm-register",
  "medico-legal",
  "patient-merges",
]);

export const isInsightsSupportedReportType = (reportType) => !UNSUPPORTED_REPORT_TYPES.has(reportType);
